import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CardBody,
  Row,
  Col,
  FormGroup,
  Label,
} from "reactstrap";
import {Field, withFormik} from "formik";
import {compose} from 'redux'
import {connect} from "react-redux";
import {
  setNewProjectInfo,
  getSchemaTemplate,
  projectNewToggle,
  emptyNewProjectSchema,
  getProjectsByAssets
} from "../../../store/actions";

import ReactSelect from "./Select";
import * as Yup from "yup";

class AddModal extends React.Component {
  state = {
    modal: false,
  };

  handleSelect = (value) => {
    const {setValues, values} = this.props;

    let myvalue = value.id;
    setValues({...values, asset: myvalue});
  };

  handleClick = () => {
    const {validateForm, emptyNewProjectSchema,
      setNewProjectInfo, toggle, getSchemaTemplate, projectNewToggle,
      isOpenTabIndexChange, values, getProjectsByAssets} = this.props;
    const prom = validateForm();

    prom.then((d) => {
      if (Object.keys(d).length === 0) {
        emptyNewProjectSchema();
        getSchemaTemplate(values.asset);
        getProjectsByAssets(values.asset);
        setNewProjectInfo({name: values.name, assetSchemaId: values.asset});
        toggle();
        projectNewToggle(true);
        isOpenTabIndexChange(values.asset, true);
      }
    });

  };

  render() {
    const {className, errors, isOpen, allAssetSchemas, toggle} = this.props;

    return (
      <div>
        <Modal
          isOpen={isOpen}
          toggle={this.toggle}
          className={className}
        >
          <ModalHeader toggle={this.toggle}>Add new project</ModalHeader>
          <ModalBody>
            <CardBody>
              <Row>
                <Col xs="8">
                  <FormGroup onSubmit={() => {
                  }}>
                    <Label htmlFor="name">Set a name</Label>
                    <Field
                      className={errors.name && 'red-border-inp' || ''}
                      type="text"
                      name='name'
                      placeholder="Enter your name"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="8">
                  <FormGroup>
                    <Label htmlFor="name">Select asset type</Label>{" "}
                    {errors.asset && <p style={{color: 'red'}}>{errors.asset}</p>}
                    <ReactSelect
                      allSchemas={allAssetSchemas}
                      handleSelect={this.handleSelect}
                      state_key={"asset_id"}
                      name={'asset'}
                      className={errors.asset && 'red-border-inp' || ''}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.handleClick}>
              Add
            </Button>{" "}
            <Button color="secondary" onClick={toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default compose(
  connect(
    null,
    {getSchemaTemplate, setNewProjectInfo, projectNewToggle, emptyNewProjectSchema, getProjectsByAssets}
  ),
  withFormik({
    mapPropsToValues() {
      return {
        name: '',
        asset: ''
      }
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required('Name is required'),
      asset: Yup.string().required('Asset is required'),
    })
  })
)(AddModal);



// WEBPACK FOOTER //
// ./src/views/Projects/Projects/Modal.js